import { Error } from './banner.error'
import { Warning } from './banner.warning'
import { ErrorWithTitle } from './banner.errorWithTitle'
import { InfoWithTitle } from './banner.infoWithTitle'
import { Info } from './banner.info'
import { BannerProps } from './types'
import './styles.scss'

export const Banner = (props: BannerProps) => <Warning {...props} />

Banner.Warning = Warning
Banner.Error = Error
Banner.Info = Info
Banner.ErrorWithTitle = ErrorWithTitle
Banner.InfoWithTitle = InfoWithTitle
